import axios from 'axios'

export default {
    namespaced: true,
    state: {
        lessons: [],
    },
    getters: {
        getListLessons: state => state.lessons,
    },
    mutations: {
        setListLessons: (state, lessons) => {
            state.lessons = lessons
        },
    },
    actions: {
        fetchLessons(ctx, queryParams) {
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken');
            return new Promise((resolve, reject) => {
                axios
                    .get('user-lessons', { params: queryParams })
                    .then(response => {
                        ctx.commit('setListLessons', response.data.data.lessons)
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
    },
}